/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { forwardRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownMenu1 } from "../../../../_partials/dropdowns";
import { NavLink } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { SystemUserUiSettings } from "../../../../../app/modules/SystemUser/pages/_redux/system-user-childs/SystemUserUiSettings";
const QuickActionsDropdownToggle = forwardRef((props, ref) => {
  const user = useSelector((state) => state.auth.user, shallowEqual);

  var systemUserUiSettings = new SystemUserUiSettings();
  systemUserUiSettings.Set(user);

  if (systemUserUiSettings.isCustomer) {
    return (
      <NavLink className="menu-link" to="/invoice">
        <button className="btn btn-primary" type="button">
          Upload New trade document
          <span className="svg-icon-sm svg-icon-primary ml-3">
            <SVG
              width="15px"
              height="15px"
              src={toAbsoluteUrl(
                "/media/svg/icons/Files/Upload.svg"
              )}
            ></SVG>
          </span>
        </button>
      </NavLink>
    );
  } else {
    return (
      <span></span>

      // <a
      //   href="#"
      //   ref={ref}
      //   onClick={(e) => {
      //     e.preventDefault();
      //     props.onClick(e);
      //   }}
      //   id="kt_subheader_quick_actions"
      //   className={`btn btn-primary btn-fixed-height font-weight-bold px-2 px-lg-5 mr-2`}
      // >
      //   <span className="svg-icon svg-icon-lg">
      //     <SVG src={toAbsoluteUrl("/media/svg/icons/Files/File.svg")} />
      //   </span>
      //   {` `}Upload New Invoice File
      // </a>
    );
  }
});

export function QuickActions() {
  return (
    <>
      <Dropdown className="dropdown-inline" drop="down" alignRight>
        <Dropdown.Toggle
          as={QuickActionsDropdownToggle}
          id="dropdown-toggle-quick-actions-subheader"
        />

        <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-right">
          <DropdownMenu1 />
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}
